export const INPUT_CLS =
  "w-full rounded-xl border border-ink/10 bg-white px-4 py-3 text-sm text-ink placeholder:text-stone-400 outline-none focus:border-gold focus:ring-2 focus:ring-gold/20 transition";
